import React from 'react';
import cn from 'classnames';
import styles from './CardIconButton.module.css';
import Icon from '../../Icon';

type IconType = 'icon2' | 'icon3' | 'share_icon' | 'shareLinkIcon' | 'sharePrintIcon';

interface CardIconButtonProps {
  iconType: IconType;
  isActive?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

const CardIconButton: React.FC<CardIconButtonProps> = ({ iconType, isActive, onClick }) => {
  const buttonClass = cn(
    styles.wrapper,
    styles[iconType],
    {
      [styles.clicked]: isActive,
    }
  );

  return (
    <button className={buttonClass} onClick={onClick}>
      <Icon
        name={iconType}
        className={styles.icon}
        width="18"
        height="18"
      />
    </button>
  );
};

export default CardIconButton;
